import { cva } from '@/styled-system/css';

export const closeButtonRecipe = cva({
  base: {
    alignItems: 'center',
    cursor: 'pointer',
    display: 'inline-flex',
    justifyContent: 'center',
    position: 'relative',
    transition: {
      _motionReduce: 'none',
      _motionSafe:
        'box-shadow 200ms ease, background-color 200ms ease, border-color 200ms ease, color 200ms ease',
    },
    boxShadow: {
      base: 'inset 0 0 0 {borderWidths.default} var(--shadow-color)',
      _focusVisible: 'inset 0 0 0 {borderWidths.default} var(--shadow-color), {shadows.focus}',
    },
    height: 'action.sm',
    width: 'action.sm',
    borderRadius: 'shape.ellipse',
  },
  variants: {
    disabled: {
      true: {
        opacity: 'disabled',
        cursor: 'default',
      },
      false: {},
    },
    onImpact: {
      true: {
        backgroundColor: {
          base: 'bg.invisible',
        },
        boxShadowColor: {
          base: 'transparent.invisible',
        },
        color: {
          base: 'CloseButton.icon.onImpact.default',
        },
      },
      false: {
        backgroundColor: {
          base: 'bg.action.bare.neutral.default',
        },
        boxShadowColor: {
          base: 'transparent.invisible',
        },
        color: {
          base: 'icon.neutral',
        },
      },
    },
  },
  compoundVariants: [
    {
      onImpact: true,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'bg.action.impact.bare.hover',
          _active: 'bg.action.impact.bare.pressed',
        },
        boxShadowColor: {
          _hover: 'transparent.invisible',
          _active: 'transparent.invisible',
        },
        color: {
          _hover: 'icon.neutral',
          _active: 'icon.neutral',
        },
      },
    },
    {
      onImpact: false,
      disabled: false,
      css: {
        backgroundColor: {
          _hover: 'bg.action.bare.neutral.hover',
          _active: 'bg.action.bare.neutral.pressed',
        },
        boxShadowColor: {
          _hover: 'transparent.invisible',
          _active: 'transparent.invisible',
        },
        color: {
          _hover: 'icon.neutral-fixed',
          _active: 'icon.neutral-fixed',
        },
      },
    },
  ],
});
